const showSpinner = (classItem) => {
  const element = document.querySelector("." + classItem);
  const spinnerContainerTag = document.createElement("div");
  const spinnerTag = document.createElement("img");
  spinnerContainerTag.className = "adl-spinner-loader-container";
  spinnerTag.src = "/assets/img/hilite.gif";
  spinnerTag.className = "img-fluid";
  spinnerContainerTag.appendChild(spinnerTag);
  element.appendChild(spinnerContainerTag);
};

const removeSpinner = (classItem) => {
  if (
    // document.querySelector(
    //   `.${CLASS_CONTENT_WRAPPER_TAG} .${CLASS_SPINNER_LOADER_CONTAINER}`
    // )
    document.querySelector(`.${CLASS_SPINNER_LOADER_CONTAINER}`)
  ) {
    const spinnerLoaderContainer = document.querySelector(
      `.${classItem} .adl-spinner-loader-container`
    );
    spinnerLoaderContainer.remove();
  }
};

const scrollForSeeMessage = (tagHtmlSelector) => {
  const element = document.querySelector(tagHtmlSelector);
  element.scrollIntoView()
};

const CLASS_CONTENT_WRAPPER_TAG = "content-wrapper";
const CLASS_SPINNER_LOADER_CONTAINER = "adl-spinner-loader-container";
const CONTAINER_AUTH_PAGE = "container-auth-page";

export default {
  showSpinner,
  removeSpinner,
  scrollForSeeMessage,
  CLASS_CONTENT_WRAPPER_TAG,
  CLASS_SPINNER_LOADER_CONTAINER,
  CONTAINER_AUTH_PAGE,
};
